"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var formatFunctions_1 = require("../formatFunctions");
function getValidations(schema, validators, cache) {
    var funcs = cache
        ? validators.validationFunctions
        : undefined;
    if (funcs === undefined) {
        funcs = [];
        if (schema.type === 'array') {
            if (validators.minItems !== undefined) {
                funcs.push(_validations.minItems);
            }
            if (validators.maxItems !== undefined) {
                funcs.push(_validations.maxItems);
            }
        }
        else {
            if (schema.type === 'string') {
                if (validators.minimum !== undefined) {
                    if (String.prototype) {
                        funcs.push(_validations.minimumString);
                    }
                }
                if (validators.exclusiveMinimum !== undefined) {
                    // let nn: number = schema.exclusiveMinimum;
                    funcs.push(_validations.exclusiveMinimumString);
                }
                if (validators.maximum !== undefined) {
                    funcs.push(_validations.maximumString);
                }
                if (validators.exclusiveMaximum !== undefined) {
                    funcs.push(_validations.exclusiveMaximumString);
                }
                if (validators.maxLength !== undefined) {
                    funcs.push(_validations.maxLength);
                }
                if (validators.minLength !== undefined) {
                    funcs.push(_validations.minLength);
                }
                if (validators.pattern !== undefined) {
                    try {
                        var rg_1 = new RegExp(validators.pattern || '', validators.patternFlags || 'i');
                        funcs.push(function (value, runschema) { return (rg_1.test(value) ? null : 'pattern'); });
                        // tslint:disable-next-line: no-empty
                    }
                    catch (err) {
                        if (process.env.NODE_ENV === 'development') {
                            console.error("[DEBUG] get RegEx from \"" + validators.pattern + "\"", err);
                            // tslint:disable-next-line: no-debugger
                            debugger;
                        }
                        funcs.push(function (value, runschema) { return 'pattern'; });
                    }
                }
                if (validators.format !== undefined) {
                    // const ff = formatFunctions[schema.format];
                    var ff_1 = formatFunctions_1.checkFormatFunction(validators.format || '');
                    // console.log('get format function', schema.format, ff);
                    if (ff_1 !== undefined) {
                        funcs.push(function (value, runschema) { return (ff_1(value) ? null : 'format'); });
                    }
                }
            }
            else {
                if (validators.minimum !== undefined) {
                    if (String.prototype) {
                        funcs.push(_validations.minimum);
                    }
                }
                if (validators.exclusiveMinimum !== undefined) {
                    // let nn: number = schema.exclusiveMinimum;
                    funcs.push(_validations.exclusiveMinimum);
                }
                if (validators.maximum !== undefined) {
                    funcs.push(_validations.maximum);
                }
                if (validators.exclusiveMaximum !== undefined) {
                    funcs.push(_validations.exclusiveMaximum);
                }
            }
            if (validators.enum !== undefined) {
                funcs.push(_validations.enum);
            }
            if (schema.type === 'number' || schema.type === 'integer' || schema.type === 'money') {
                if (validators.multipleOf) {
                    funcs.push(_validations.multipleOf);
                }
            }
        }
        if (cache) {
            Object.defineProperty(validators, 'validationFunctions', {
                enumerable: false,
                value: funcs
            });
        }
    }
    return funcs;
}
exports.getValidations = getValidations;
var supportLocales = false;
try {
    'foo'.localeCompare('bar', 'pl');
    supportLocales = true;
}
catch (_a) {
    supportLocales = false;
}
var stringCompare = function (value, othervalue) {
    return value.toLocaleLowerCase().localeCompare(othervalue.toLocaleLowerCase());
};
// nie ma sensu bo jest wolniejsze, jakieś 20x
// if (supportLocales) {
//    stringCompare = (value: any, othervalue: any) => value.localeCompare(othervalue, 'pl', { sensitivity: 'accent' });
// }
var _validations = {
    enum: function (value, runschema) {
        return runschema.enum && runschema.enum.indexOf(value) > -1 ? null : 'enum';
    },
    minItems: function (value, runschema) {
        return runschema.minItems !== null && !isNaN(runschema.minItems) && value.length < runschema.minItems ? 'minItems' : null;
    },
    maxItems: function (value, runschema) {
        return runschema.maxItems !== null && !isNaN(runschema.maxItems) && value.length > runschema.maxItems ? 'maxItems' : null;
    },
    multipleOf: function (value, runschema) {
        return runschema.multipleOf !== null && !isNaN(runschema.multipleOf) && value % runschema.multipleOf !== 0
            ? 'multipleOf'
            : null;
    },
    maxLength: function (value, runschema) {
        return runschema.maxLength !== null && !isNaN(runschema.maxLength) && value.length > runschema.maxLength
            ? 'maxLength'
            : null;
    },
    minLength: function (value, runschema) {
        return runschema.minLength !== null && !isNaN(runschema.minLength) && value.length < runschema.minLength
            ? 'minLength'
            : null;
    },
    minimum: function (value, runschema) {
        return runschema.minimum !== null && !isNaN(runschema.minimum) && value < runschema.minimum ? 'minimum' : null;
    },
    exclusiveMinimum: function (value, runschema) {
        return runschema.exclusiveMinimum !== null && !isNaN(runschema.exclusiveMinimum) && value <= runschema.exclusiveMinimum
            ? 'exclusiveMinimum'
            : null;
    },
    maximum: function (value, runschema) {
        return runschema.maximum !== null && !isNaN(runschema.maximum) && value > runschema.maximum ? 'maximum' : null;
    },
    exclusiveMaximum: function (value, runschema) {
        return runschema.exclusiveMaximum !== null && !isNaN(runschema.exclusiveMaximum) && value >= runschema.exclusiveMaximum
            ? 'exclusiveMaximum'
            : null;
    },
    minimumString: function (value, runschema) {
        return runschema.minimum && stringCompare(value, runschema.minimum) === -1 ? 'minimum' : null;
    },
    exclusiveMinimumString: function (value, runschema) {
        return runschema.exclusiveMinimum && stringCompare(value, runschema.exclusiveMinimum) !== 1 ? 'exclusiveMinimum' : null;
    },
    maximumString: function (value, runschema) {
        return runschema.maximum && stringCompare(value, runschema.maximum) === 1 ? 'maximum' : null;
    },
    exclusiveMaximumString: function (value, runschema) {
        return runschema.exclusiveMaximum && stringCompare(value, runschema.exclusiveMaximum) !== -1 ? 'exclusiveMaximum' : null;
    }
};
//# sourceMappingURL=getValidations.js.map